













import { Component, Vue } from "vue-property-decorator";

@Component
export default class NotFound404 extends Vue {}
